/**
 * Preview media on the catalog plates.
 *
 * Off. The generated WebGL scenes were not good enough to ship, and real
 * screenshots will replace them.
 *
 * Nothing was deleted. `src/previews/` and `src/preview-layer.tsx` are intact,
 * and the plate frame styling is still in `styles.css`. Turning this back on
 * restores the scenes exactly as they were.
 *
 * When screenshots arrive, the frame is the container to put them in: render an
 * <img> inside `.plate__frame` in Plate.tsx instead of the GameView, and this
 * flag stops being about WebGL at all.
 *
 * While off, three.js is never imported, so the chunk is not in the build.
 */
export const PREVIEWS_ENABLED = false
